import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';
import { Colors } from '../../../utils/resources/colors';


export interface ImageButtonCSSStyle extends UIComponentCSSStyle
{
    getImageButtonStyle(): object;
    getImageIconButtonStyle(): object;
    getImageButtonText(): object;
}

export class ImageButtonCSSStyleImpl extends UIComponentCSSStyleImpl implements ImageButtonCSSStyle 
{ 
    getWrapperCSSStyle(): object 
    {
       return {
        position: 'relative', 
        height: '50px', 
        width: '100%', 
        cursor: "default",
        outline:'none'
      };
    }

    getImageButtonStyle(): object 
    {
       return {
        width:'100%',
        height: '50px',
        float: 'left', 
        borderRadius: '25px',
        overflow: 'hidden',
        backgroundColor: this.getResources().getColor(Colors.color_5),
        cursor: "pointer",
        border: 'none',
        alignContent: 'center',
        alignItems: "center",
        justifyContent: "center",
        outline:'none'
   
      };
    }

    getImageIconButtonStyle(): object 
    {
       return {
        width:'16px',
        height: '16px',
        marginLeft: "15px",
        marginTop: "5px",
        float: 'left', 
      };
    }

    getImageButtonText(): object 
    {
        return {
            color: this.getResources().getColor(Colors.color_4), 
            fontSize: "16px", 
            fontFamily: this.getResources().getFontFamily(), 
            lineHeight: "20px",
            textAlign: "center",
            height: "20px",
            paddingTop: "5px",
            // width: "118px",
            // textTransform: "uppercase",
            cursor: "pointer"
       };
     } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/imagebutton/imagebuttoncss.tsx